import React, { createContext, useState, useEffect } from 'react';

export const ChatVisibilityContext = createContext({
  chatExpanded: true,
  setChatExpanded: () => {},
});

export const ChatVisibilityProvider = ({ children }) => {
  const [chatExpanded, setChatExpanded] = useState(() => {
    const fromLS = localStorage.getItem('chatExpanded');
    return fromLS ? JSON.parse(fromLS) : true;
  });

  useEffect(() => {
    localStorage.setItem('chatExpanded', JSON.stringify(chatExpanded));
  }, [chatExpanded]);

  return (
    <ChatVisibilityContext.Provider value={{ chatExpanded, setChatExpanded }}>
      {children}
    </ChatVisibilityContext.Provider>
  );
};
